// Math utility functions

export function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getRandomFloat(min: number, max: number): number {
  return Math.random() * (max - min) + min
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max)
}

export function clamp01(value: number): number {
  return Math.min(Math.max(value, 0), 1)
}

export function interpolate(min: number, max: number, value: number): number {
  return (max - min) * clamp01(value) + min
}
